import { render, staticRenderFns } from "./ElectronicVEC.vue?vue&type=template&id=1cb9804c&scoped=true"
import script from "./ElectronicVEC.vue?vue&type=script&lang=js"
export * from "./ElectronicVEC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9804c",
  null
  
)

export default component.exports